import React from 'react';
import {
	Loader,
	BaasicTable,
	BaasicHeader,
	TableFilter,
	BaasicConfirmModal,
	BaasicCheckbox,
	BaasicTableExport,
} from 'core/components';
import ReactTooltip from 'react-tooltip';
import { defaultTemplate } from 'core/hoc';
import { fileNames } from 'common/constants';
import { OrderDateRangeFilter } from 'modules/order/pages';

const ShipmentInfoListTemplate = ({
	t,
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
		loading,
		baasicTableSettingsViewStore,
		columnFilterSetup,
		onCheck,
		showYesterdayShipments,
		findShipmentInfos,
		removeFiltersModal,
		orderDateRangeViewStore,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="flex--grow--1">
			<BaasicHeader
				title="SHIPMENTSTATUSVIEW.FULFILLMENTSHIPMENTS"
				baasicTableSettingsViewStore={baasicTableSettingsViewStore}
				reloadFunc={findShipmentInfos}
			>
				{!showYesterdayShipments && <OrderDateRangeFilter orderDateRangeViewStore={orderDateRangeViewStore} />}
				<div className="layout__main__subheader__item align--h--right">
					<BaasicCheckbox
						id={'showYesterdayShipments'}
						onChangeCallback={onCheck}
						label="SHIPMENTSTATUSVIEW.SHOWYESTERDAYSHIPMENTS"
						checked={showYesterdayShipments}
						className="input--check input--check--negative"
					/>
				</div>
				<BaasicTableExport tableViewStore={viewStore} fileTitle={fileNames.shipmentInfo} />
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
				}}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
			<ReactTooltip />
			<TableFilter {...{ viewStore, columnFilterSetup }} />
			{removeFiltersModal && <BaasicConfirmModal modalParams={removeFiltersModal.removeFiltersConfirm} />}
		</section>
	);
};

export default defaultTemplate(ShipmentInfoListTemplate);
